import { createAction } from '@reduxjs/toolkit';

/**
 * "Signal" actions: intents the UI dispatches for the saga to act on. They are
 * deliberately kept out of the slice's reducers: they trigger side effects, not
 * state transitions (the saga owns the `exportStarted/Succeeded/Failed` ones).
 */

/** Run the export with the current selections (Choose Columns → download). */
export const exportRequested = createAction('profileExport/exportRequested');
